import { apiService } from "../api.service";

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export const changePassword = async (form: ChangePasswordRequest): Promise<any> => {
  return apiService.apiRequest<any>("patch", "users/me/change-password", form);
};
